import * as actionsType from './../actions/types.js';

const initialState = {
  showSpinner:false,
  progressBarCounter:0,
  progressBarCounterEnd:0,
  location:'/',
  showLogIn: false,
  showListAdder:false,
  listAdderListName:'',
  showSendMassage:false,
  sendMassageCustomersList:"",
  sendMassageChannel:"EMAIL",
  backgrondColor:"white"
};

export default function showModelsReducer(state = initialState,action){
  switch(action.type) {
    case actionsType.SET_SHOW_LOGIN:{
      return ({...state,showLogIn: action.show});
    }
    case actionsType.SET_SHOW_LIST_ADDER:{
      return ({...state,showListAdder: action.show,listAdderListName:action.listName});
    }
    case actionsType.SET_LOCATION:{
      return ({...state,location: action.location});
    }
    case actionsType.SET_SHOW_SPINNER:{
      return ({...state,showSpinner: action.show,progressBarCounter:action.progressBarCounter,progressBarCounterEnd:action.progressBarCounterEnd});
    }
    case actionsType.SET_SHOW_SEND_MASSAGE:{
      return ({...state,showSendMassage: action.show,sendMassageCustomersList:action.sendMassageCustomersList,sendMassageChannel:action.sendMassageChannel||"EMAIL"});
    }
    case actionsType.SET_BACKGROUND_COLOR:{
      return ({...state,backgrondColor: action.color});
    }




    default: return state;
  }
}
